export class RecyclingFolderAttachment {
  constructor(
    technicalId,
    recyclingFolderId,
    authorId,
    authorFirstname,
    authorLastname,
    attachmentName,
    filePath,
    attachmentCounter,
    createdAt
  ) {
    this.technicalId = technicalId
    this.recyclingFolderId = recyclingFolderId
    this.authorId = authorId
    this.authorFirstname = authorFirstname
    this.authorLastname = authorLastname
    this.attachmentName = attachmentName
    this.filePath = filePath
    this.attachmentCounter = attachmentCounter
    this.createdAt = createdAt
  }
}
